import type { QueryClient } from '@tanstack/react-query'
import { currentSelfQueryOptions } from '../../lib/performance/queryOptions'

/** Recheck the server; never infer a grant from a cached role or local storage. */
export async function refreshTicketAccess(client: QueryClient) {
  await client.invalidateQueries({ queryKey: ['authUser'], exact: true, refetchType: 'none' })
  await client.invalidateQueries({ queryKey: ['current-self'], exact: true, refetchType: 'none' })
  const self = await client.fetchQuery({ ...currentSelfQueryOptions(client), staleTime: 0 })
  await client.invalidateQueries({ queryKey: ['tickets'] })
  return self
}
